import { ChoiceMetadataType } from '@/modules/types/choice';
import { QuizQuestion } from '@/modules/types/question';
import { Col, Radio, Row } from 'elmo-elements';
import React, { ReactElement } from 'react';
import { useController, useFormContext } from 'react-hook-form';

export const TrueOrFalse = (): ReactElement => {
  const choices = [
    { content: 'True', position: 1, type: ChoiceMetadataType.main },
    { content: 'False', position: 0, type: ChoiceMetadataType.main },
  ];

  const { control } = useFormContext<QuizQuestion>();

  const { field: radioField } = useController({
    control,
    name: 'answer',
  });

  return (
    <Row>
      <Col xs={24}>
        <div className="choice-group">
          {choices.map((choice, index) => (
            <div className="choice" key={choice.content + index}>
              <Radio
                id={choice.content}
                name="answer"
                checked={choice.position === +(radioField.value || 0)}
                value={choice.position}
                onChange={(e: any) => {
                  radioField.onChange(e);
                }}
              >
                {choice.content}
              </Radio>
            </div>
          ))}
        </div>
      </Col>
    </Row>
  );
};

export default TrueOrFalse;
